import store from 'src/store'
import Auth from '@aws-amplify/auth'
import { START_LOCATION } from 'vue-router'
import { obterRotaDeLoginComRedirect } from './redirect-login'
import { obterDestinoDoSetup, URL_DO_BORA } from '@/components/TermosDeUso/setupDoBora'

export const LOGIN_PATH = '/cognito/login'

export async function verifyAuthAndLoadUserAndStyles (to, from, next) {
  if ((to.path === from.path && from.name) || to.path.includes('HotUpdate')) {
    next()
    return
  }

  // logout if is main view and has not access tokens saved in cookies
  if (to.path === '/login') {
    await store.dispatch('logout')
    next()
    return
  }

  if (to.path !== LOGIN_PATH && to.meta.dontNeedAuth !== true && !store.state.userInfo) {
    if (!store.getters.usuarioEstaAutenticado) {
      next(obterRotaDeLoginComRedirect(to))
      return
    }

    const possuiDadosUsuario = await store.dispatch('getUserInfo')
    if (possuiDadosUsuario === false) {
      next(false)
      return
    }
  }

  if (from === START_LOCATION && store.state.userInfo) {
    // Browser just loaded
    await store.dispatch('getVisual', {forceReload: true})
  }

  if (to.path !== LOGIN_PATH && to.meta.dontNeedAuth !== true) {
    const destinoDoSetup = obterDestinoDoSetup(store.state.userInfo)

    if (destinoDoSetup === 'termos' && to.name !== 'home') {
      next({ name: 'home' })
      return
    }

    if (destinoDoSetup === 'bora') {
      window.location.replace(URL_DO_BORA)
      next(false)
      return
    }
  }

  next()
}

export async function retrieveCurrentAuthenticatedUserAmplify () {
  // loads the user in amplify. It must save the user in localstorage or something like that
  if (!store?.state?.auth?.userPoolId || !store?.state?.auth?.userPoolWebClientId) {
    return
  }

  try {
    const currentUser = await Auth.currentAuthenticatedUser()
    const { idToken } = await Auth.currentSession()
    if (currentUser) {
      store.commit('setFreshToken', idToken)
    }
  } catch {

  }
}
